import { render, staticRenderFns } from "./VistaSeleccionAdministracion.vue?vue&type=template&id=040952d2"
import script from "./VistaSeleccionAdministracion.vue?vue&type=script&lang=js"
export * from "./VistaSeleccionAdministracion.vue?vue&type=script&lang=js"
import style0 from "./VistaSeleccionAdministracion.vue?vue&type=style&index=0&id=040952d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
